import firebase from "firebase";
import { collectionRef, collectionGroup, workersRef } from "./firebase";
const LOCATIONS_DEV = "locations";
const CAPACITY_PLANNING = "capacityPlanning";
const BUILDING_IDS = "buildingIds";
const DISTRICT_ID = "districtId";
const START_DATE = "weekStartDate";
const PRIMARY_BUILDING = "primaryBuilding";
const DSC_EMPLOYEE_PLAN = "dscEmployeePlan";

const formatDscId = (id) => {
  return `act_${id}`;
};

const normalizeParentId = (activity) => {
  if (activity.parentId != null) {
    return formatDscId(activity.parentId);
  } else {
    return formatDscId(activity.id);
  }
};

const preProcess = (activities) => {
  if (!activities) return [];
  // .filter((e)=>e!='UNREG. FILE/DOC Search')
  return Object.keys(activities)
    .filter((id) => activities[id].id && activities[id].capacity)
    .map((id) => ({
      ...activities[id],
      capacity: normalize(activities[id].capacity),
      id: formatDscId(activities[id].id),
      parentId: normalizeParentId(activities[id]),
      idNum:id
    }));
};

const normalize = (value) => {
  if (!value) return "";
  let n = parseFloat(value);
  if (n == 0) {
    return 0;
  } else {
    return n.toFixed(2);
  }
};

export const getActivities = (district, building) => {
  return new Promise((resolve, reject) => {
    collectionRef(LOCATIONS_DEV)
      .doc(district)
      .collection("buildings")
      .doc(building)
      .collection("dscActivities")
      .doc(building)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        if (data.activities != undefined) {
          let response ={
            activities:preProcess(data.activities),
            averages:data.averages?data.averages:{}
          }
          resolve(response);
        } else {
          resolve([]);
        }
      })
      .catch((error) => {
        console.error("in services > dsc > getActivities, err===" + error);
        reject(new Error("Some error occurred in getActivities"));
      });
  });
};

export const getMultipleActivities = (district, buildings) => {
  if (!Array.isArray(buildings)) return [];
  if (buildings.length == 0) return [];

  const promises = buildings.map((building) =>
    getActivities(district, building)
  );

  return new Promise((resolve, reject) => {
    Promise.allSettled(promises)
      .then((responses) => {
        const activitiesResponse = [];
        for (let i = 0; i < buildings.length; ++i) {
          activitiesResponse.push({
            building: buildings[i],
            activities: responses[i].status == "fulfilled" ? responses[i].value.activities : [],
            averages: responses[i].status == "fulfilled" ? responses[i].value.averages : {}
          });
        }
        resolve(activitiesResponse);
      })
      .catch((error) => {
        console.error(
          "in services > dsc > getMultipleActivities, err===" + error
        );
        reject(new Error("Some error occurred in getMultipleActivities"));
      });
  });
};

export const getLocationDevDetails = async (country) => {
  console.log("services > dsc > getLocationDevDetails called...");
  return new Promise((res, rej) => {
    try {
      return (
        collectionGroup("buildings")
          // .where("collectionName", "==", LOCATIONS_DEV)
          .get()
          .then((snapshot) => {
            // console.log("------- getLocationDevDetails snapshot in dsc js------",snapshot);
            const buildings = snapshot.docs
              .map((doc) => ({
                id: doc.id,
                data: doc.data(),
              }))
              .filter((e) =>
                e.data.collectionName
                  ? e.data.collectionName == LOCATIONS_DEV
                  : false
              );

            let buildingsData = buildings
              .filter((e) => e.data.country == country)
              .filter((e) => e.data.planningEnabled);

            console.log("buildingsData", buildingsData);

            if (buildingsData.length === 0) {
              buildingsData = buildings;
            }
            //.filter((e) =>
            //country == "testCountry" ? true : e.data.country == country)
            const obj = {};
            for (let item of buildingsData) {
              const { id, data } = item;
              const districtName = data.districtName;
              if (!obj[districtName]) {
                obj[districtName] = { [id]: data };
              } else {
                obj[districtName][id] = data;
              }
            }

            const output = Object.keys(obj).map((key) => ({
              district: key,
              buildings: obj[key],
            }));
            // console.log("Districts", output)

            res(output);
          })
          .catch((err) => {
            console.error(
              "in services > dsc > getLocationDevDetails, err===" + err
            );
            rej(err);
          })
      );
    } catch (error) {
      console.error(
        "in services > dsc > getLocationDevDetails, err===" + error
      );
      rej(error);
    }
  });
};

export const saveCapacityPlanningDetails = async (data) => {
  console.log("services > dsc > saveCapacityPlanningDetails called...");
  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }
      return collectionRef(CAPACITY_PLANNING)
        .add(data)
        .then((snapshot) => {
          console.log("Document successfully written!");
          res(snapshot.id);
        });
    } catch (error) {
      console.error(
        "in services > dsc > saveCapacityPlanningDetails, err===" + error
      );
      rej(error);
    }
  });
};

export const saveCapacityPlanningToHistory = async (newData, oldData, id) => {
  console.log("services > dsc > saveCapacityPlanningToHistory called...");
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (res, rej) => {
    try {
      let promise1 = collectionRef(CAPACITY_PLANNING)
        .doc(id)
        .update({ ...newData, version: firebase.firestore.FieldValue.increment(1) });
      let promise2 = collectionRef(CAPACITY_PLANNING)
        .doc(id)
        .collection("planningHistory")
        .add(oldData);
      await Promise.all([promise1, promise2]);
      res(true);
    } catch (error) {
      console.error(
        "in services > dsc > saveCapacityPlanningToHistory, err===" + error
      );
      rej(error);
    }
  });
};
export const getPlanningDataByDistrict = (districtId,weekStartDate) => {
  console.log("services > dsc > getPlanningDataByDistrict called...");
  return new Promise((resolve, reject) => {
    try {
      collectionRef(CAPACITY_PLANNING)
      .where(DISTRICT_ID, "==", districtId)
      .where(START_DATE, "==", weekStartDate)
      .get()
          .then(function (querySnapshot) {
            console.log("SS:: capacitydata data===", querySnapshot);
            let projects = [];
            querySnapshot.forEach((doc) => {
              if (doc.data() && !doc.data().isDeleted) {
                projects.push({ id: doc.id, ...doc.data() });
              }
            });
            console.log("SS:: getProjectsByCountry projects===", projects);
            resolve(projects);
          })

        .catch((err) => {
          console.error("in services > dsc > getPlanningDataByDistrict, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > dsc > getPlanningDataByDistrict, Err===", error);
      reject(error);
    }
  });
};

export const getPlanningData = (districtId, buildingId, weekStartDate) => {
  console.log("services > dsc > getPlanningData called...");
  return new Promise((resolve, reject) => {
    try {
      collectionRef(CAPACITY_PLANNING)
        .where(DISTRICT_ID, "==", districtId)
        .where(PRIMARY_BUILDING, "==", buildingId)
        .where(START_DATE, "==", weekStartDate)
        .get()
        .then((snapshot) => {
          const size = snapshot.size;
          if (size > 0) {
            const plans = snapshot.docs.map((d) => ({
              plan: d.data(),
              docId: d.id,
            }));
            resolve(plans);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.error("in services > dsc > getPlanningData, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > dsc > getPlanningData, Err===", error);
      reject(error);
    }
  });
};

export const getWorkersFromBuilding = (districtId, buildingId) =>{
  console.log("services > dsc > getWorkersFromBuilding called...");
  return new Promise((resolve, reject) => {
    try {
      workersRef()
        .where('operationalBuilding', "array-contains", buildingId)
      //  .where(PRIMARY_BUILDING, "==", buildingId)
        .where('isActiveWorker', "==", true)
        .get()
        .then((snapshot) => {
          const size = snapshot.size;
          const workers = {};
          if (size > 0) {
            snapshot.docs.forEach((d) => {
              const data = d.data();
              workers[d.id] =  {
                docId: d.id,
                workerId: data.workerId,
                fullName: `${data.firstName} ${data.lastName}`,
                email: data.email,
                label: `${data.firstName} ${data.lastName} (${d.id})`,
                managerId: data.managerId,
                managerFullname: `${data.managerFirstName} ${data.managerLastName}`,
                managerEmail: data.managerEmail
              }
          });
            resolve(workers);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.error("in services > dsc > getWorkersFromBuilding, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > dsc > getWorkersFromBuilding, Err===", error);
      reject(error);
    }
  });
}

export const saveDSCEmployeePlan = async (newData, oldData, id) => {
  console.log("services > dsc > saveDSCEmployeePlan called...");
  return new Promise(async (res, rej) => {
    if (!newData) {
      return rej(new Error("Data is null"));
    }
    try {
      if(oldData && id){
      let promise1 = collectionRef(DSC_EMPLOYEE_PLAN)
        .doc(id)
        .update({ ...newData, version: firebase.firestore.FieldValue.increment(1) });
      let promise2 = collectionRef(DSC_EMPLOYEE_PLAN)
        .doc(id)
        .collection("employeePlanHistory")
        .add(oldData);
      await Promise.all([promise1, promise2]);
      }else{
         await collectionRef(DSC_EMPLOYEE_PLAN)
        .add(newData)
        .then((snapshot) => {
          console.log("Document successfully written!");
          res(snapshot.id);
        });
      }      
      res(true);
    } catch (error) {
      console.error(
        "in services > dsc > saveDSCEmployeePlan, err===" + error
      );
      rej(error);
    }
  });
};

export const getDSCEmployeePlanningData = (districtId, buildingId, weekStartDate) => {
  console.log("services > dsc > getDSCEmployeePlanningData called...");
  return new Promise((resolve, reject) => {
    try {
      collectionRef(DSC_EMPLOYEE_PLAN)
        .where(DISTRICT_ID, "==", districtId)
        .where("buildingId", "==", buildingId)
        .where(START_DATE, "==", weekStartDate)
        .get()
        .then((snapshot) => {
          const size = snapshot.size;
          if (size > 0) {
            const plans = snapshot.docs.map((d) => ({
              plan: d.data(),
              docId: d.id,
            }));
            resolve(plans);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.error("in services > dsc > getDSCEmployeePlanningData, err===" + err);
          reject(err);
        });
    } catch (error) {
      console.error("in services > dsc > getDSCEmployeePlanningData, Err===", error);
      reject(error);
    }
  });
};
